import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

export interface IPdfViewerProps {
  fileUrl: any;
  pdfHeight?: string;
}

export function PdfViewer({ fileUrl, pdfHeight }: IPdfViewerProps) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  if (!fileUrl) {
    return (
      <div
        style={{
          width: "100%",
          height: pdfHeight ?? "20rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f5f5",
        }}
      >
        📄 No PDF file available
      </div>
    );
  }
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <div style={{ width: "100%", height: pdfHeight ?? "20rem" }}>
        <Viewer
          fileUrl={fileUrl}
          plugins={[defaultLayoutPluginInstance]}
          renderError={(error) => (
            <div
              style={{
                height: pdfHeight ?? "20rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                textAlign: "center",
                padding: "1rem",
              }}
            >
              <strong>Unable to display this PDF</strong>
              <small style={{ marginTop: "0.5rem", opacity: 0.7 }}>
                {error?.message || "The file may be corrupted or unsupported."}
              </small>
            </div>
          )}
        />
      </div>
    </Worker>
  );
}
